import Immutable from 'immutable';
import { OFFSET } from '../../utils/constants';

const LOAD = 'fsaOffices/LOAD';
const LOAD_SUCCESS = 'fsaOffices/LOAD_SUCCESS';
const LOAD_FAIL = 'fsaOffices/LOAD_FAIL';
const LOAD_ADD_SUCCESS = 'fsaOffices/LOAD_ADD_SUCCESS';
const LOAD_ALL_SUCCESS = 'fsaOffices/LOAD_ALL_SUCCESS';


const initialState = Immutable.fromJS({
  FsaOffices: null,
  loading: false,
  errorMessage: null,
  activePage: 1,
  AllFsaOffices: null
});

export default function reducer(state = initialState, action) {
  switch (action.type) {

    case LOAD:
    return state
    .set('loading', true);

    case LOAD_FAIL:
    return state
    .set('loading', false)
    .set('errorMessage', action.errorMessage);

    case LOAD_SUCCESS:
    return state
    .set('loading', false)
    .set('activePage', action.page)
    .set('FsaOffices', action.FsaOffices);

    case LOAD_ALL_SUCCESS:
    return state
    .set('loading', false)
    .set('AllFsaOffices', action.FsaOffices);


    case LOAD_ADD_SUCCESS:
    return state
    .set('loading', false)
    .set('activePage', action.page)
    .set('FsaOffice', action.result);

    default:
    return state;
  }
}

export const getFsaOffices = (offset, page) => async (dispatch, getState, api) => {

  dispatch({ type: LOAD });

  try {
    const res = await api.get(`/fsaOffices/${offset}`);
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: LOAD_SUCCESS, FsaOffices: res, page });
    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const getAllFsaOffices = (offset, page) => async (dispatch, getState, api) => {

  dispatch({ type: LOAD });

  try {
    const res = await api.get('/fsaOffices/fsaOfficesAll/');
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: LOAD_ALL_SUCCESS, FsaOffices: res });
    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};


export const addFsaOffices = (data) => async (dispatch, getState, api) => {

  dispatch({ type: LOAD });
  const tenant = getState().get('fsaOffices').get('FsaOffices');
  let page = Math.ceil(tenant.count / OFFSET);
  let offset = OFFSET * (page - 1);
  if (tenant.count % OFFSET === 0) {
    page = page + 1;
  }
  try {

    const res = await api.post('/fsaOffices', { data });

    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch(getFsaOffices(offset, page));
    dispatch({ type: LOAD_ADD_SUCCESS, result: res, page });
    return res;
  } catch (error) {

    dispatch({ type: LOAD_FAIL, errorMessage: error.message || error });
  }
};


export const updateFsaOffices = (data) => async (dispatch, getState, api) => {

  dispatch({ type: LOAD });
  const page = getState().get('fsaOffices').get('activePage');
  let offset = OFFSET * (page - 1);
  try {

    const res = await api.put('/fsaOffices', { data });

    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch(getFsaOffices(offset, page));
    dispatch({ type: LOAD_ADD_SUCCESS, result: res, page });
    return res;
  } catch (error) {

    dispatch({ type: LOAD_FAIL, errorMessage: error.message || error });
  }
};


export const deleteFsaOffices = (data) => async (dispatch, getState, api) => {

  dispatch({ type: LOAD });
  const page = getState().get('fsaOffices').get('activePage');
  let offset = OFFSET * (page - 1);
  try {

    const res = await api.del('/fsaOffices', { data });

    if (res.message) {

      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch(getFsaOffices(offset, page));
    dispatch({ type: LOAD_SUCCESS, result: res, page });
    return res;
  } catch (error) {

    dispatch({ type: LOAD_FAIL, errorMessage: error.message || error });
  }
};


export const getFsaOfficesById = (id) => async (dispatch, getState, api) => {

  dispatch({ type: LOAD });

  try {
    const res = await api.get('/fsaOffices/fsaOfficesGetById/' + id );
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    return res;

  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};


export const updateFsaOfficesById = (data) => async (dispatch, getState, api) => {

  dispatch({ type: LOAD });
  try {

    const res = await api.put('/fsaOffices/fsaOfficesUpdateById', { data });

    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    return res;
  } catch (error) {

    dispatch({ type: LOAD_FAIL, errorMessage: error.message || error });
  }
};

export const getFarmFsaOfficesById = (fsa_id, id) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.get('/fsaOffices/farmFsaOfficesById/' + id );
    if(res === null){
      const res = await api.get('/fsaOffices/farmFsaOfficesByFsaId/' + fsa_id );
      if (res.message) {
        dispatch({ type: LOAD_FAIL, errorMessage: res.message });
        return;
      }
      return res;
    } else {
      if (res.message) {
        dispatch({ type: LOAD_FAIL, errorMessage: res.message });
        return;
      }
      return res;
    }
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};



// WEBPACK FOOTER //
// ./src/redux/modules/fsaOffices.js